import { render, staticRenderFns } from "./DepartmentDetail.vue?vue&type=template&id=e0f15700&scoped=true"
import script from "./DepartmentDetail.vue?vue&type=script&lang=js"
export * from "./DepartmentDetail.vue?vue&type=script&lang=js"
import style0 from "./DepartmentDetail.vue?vue&type=style&index=0&id=e0f15700&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0f15700",
  null
  
)

export default component.exports